'use strict';

/**
 * ### Gestion du champ de recherche dans le header
 * ## TO DO
 * - état initial fermé
 * - soumission simple
 */
const headerSearch = {
	component: document.querySelector('.header_search_wrapper'),
	mql: window.matchMedia('screen and (max-width:1100px)'),
	state: {
		open: false,
		tablet: false
	},
	form: document.querySelector('.header_search_wrapper form'),
	button: document.querySelector('#open_search'),
	input: document.querySelector('.header_search_input'),

	init() {
		this.setStates();
		this.mql.addListener(() => { this.setStates(); });

		this.controllers();

		if (headerSearch.state.open) {
			this.openInput();
		}
	},
	setStates() {

		if(headerSearch.mql.matches){
			// this.state.tablet = true;
			this.openInput();
		}
		else{
			// this.state.tablet = false;
			this.closeSearchInput();
		}
		// console.log('tablet : ' + headerSearch.state.tablet + ' - open :' + headerSearch.state.open);
	},
	controllers() {
		// pour desktop
		this.form.addEventListener('submit', (event) => {
			// console.log('headerSearch : submit', event.target);
			event.preventDefault();
			event.stopPropagation();
			headerSearch.checkForm();
		});

		// quand on sort du focus
		//si on clic sur un autre élément que le champ de recherche
		document.querySelector('body').addEventListener(
			'mousedown',
			function(e) {
				if (!e.target.closest('.header_search_wrapper') && headerSearch.state.tablet === false) {
					headerSearch.closeSearchInput();
				}
			},
			true
		);
	},
	checkForm() {
		if (headerSearch.state.open) {
			console.log('headerSearch : lance la recherche --> ferme');
			// headerSearch.closeSearchInput(event);
			if(this.input.value.length > 1) {
				this.form.submit();
				this.input.classList.remove('alert');
				this.input.classList.add('submit');
			}
			else{
				this.input.classList.add('alert');
			}
		} else {
			// console.log("headerSearch : formulaire pas ouvert --> s'ouvre ", this);
			headerSearch.openInput(event);
			return false;
		}
	},
	openInput() {
		headerSearch.state.open = true;
		headerSearch.input.classList.remove('hidden');
		headerSearch.component.parentElement.classList.add('search_opened');
		headerSearch.input.focus();
	},
	closeSearchInput(e) {
		// console.log('close search', e);
		if (headerSearch.state.open) {
			headerSearch.state.open = false;
			headerSearch.input.classList.add('hidden');
			headerSearch.component.parentElement.classList.remove('search_opened');
			headerSearch.input.value = null;
		}
	}
};

export default headerSearch;



// WEBPACK FOOTER //
// ./src/scripts/components/header-search.js